import {
  Consultation,
  Patient
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { formatDate, getItemId } from "@/src/utils/utils";
import { getAnswersText, getAntecedentsText } from "./textGenerationUtils";

export async function generateConsultationSummaryHtml({
  consultation,
  patient,
}: {
  consultation: Consultation;
  patient: Patient;
}): Promise<string> {
  let parent = consultation;
  if (!parent) return "";



  function getMotivesText() {
    return parent.motives?.map((motive) => motive?.reference?.name).join(", ");
  }

  function getDiagnosticsText() {
    return parent.diagnostics
      ?.map((diagnostic) => diagnostic?.reference?.name)
      .join(", ");
  }

  async function getLastStoryText() {
    let lastStory = await apiFetch("stories", "loadLast", {
      patientId: getItemId(patient),
      parentId: null,
    });

    return `${lastStory?.notes || ""} \n ${lastStory?.conclusion || ""}`;
  }

  function getClinicalExaminationText() {
    const clinicalExam = parent.clinicalExam;
    if (!clinicalExam) return "";
    console.log("clinicalExam?.fieldAnswers",clinicalExam?.fieldAnswers)
    return `
    ${getAnswersText(clinicalExam?.fieldAnswers)}\n
    ${clinicalExam.notes || ""}\n
      <strong>${clinicalExam.conclusion || ""}</strong>\n`;
  }

  async function getExamsText() {
    let exams = await apiFetch("exams", "loadFullExams", {
      patientId: getItemId(patient),
      parentId: getItemId(parent),
    });
    return exams
      ?.map((exam) => {
        return `<strong>${exam.reference?.name} - ${exam._date}</strong>\n 
                ${getAnswersText(exam?.content?.fieldAnswers)} \n 
                <strong>${exam.conclusion}</strong>`;
      })
      .join("\n\n");
  }
  async function getExamDemandsText() {
    let examsDemands = await apiFetch("examDemands", "loadMany", {
      patientId: getItemId(patient),
      parentId: getItemId(parent),
    });
    return examsDemands
      ?.map((examDemand) => {
        return `<strong>${examDemand.reference?.name} </strong>\n `;
      })
      .join("\n-");
  }

  async function getTreatment(): Promise<string> {
    let ordonnances = await apiFetch(
      "ordonnances",
      "loadMany",
      {
        categories: null,
        patientId: getItemId(patient),
        parentId: getItemId(parent),
      },
      "Erreur lors du chargement des ordonnances"
    );

    let medicineTexts: Record<string, string> = {};

    for (let ordonnance of ordonnances) {
      for (let ordonnanceMedicine of ordonnance.ordonnanceMedicines) {
        if (!ordonnanceMedicine) continue;
        const { medicine, startDate, endDate, duration } = ordonnanceMedicine;
        if (!medicine) continue;
        let medicineId = medicine?.id;
        if (!medicineId) continue;
        medicineTexts[medicineId] ||= `<strong>${medicine.name}</strong>\n`;

        let intakesText = ``;
        for (let intake of ordonnanceMedicine?.intakes || []) {
          if (!intake) continue;
          const { unit, posology, route, horaire, notes } = intake;
          intakesText += `${posology} ${unit || ""} par voie ${route || ""} à ${
            horaire || ""
          } ${notes || ""} \n`;
        }

        medicineTexts[medicineId] += `
          ${intakesText} 
          du ${formatDate(startDate, "LL")} au ${formatDate(
          endDate,
          "LL"
        )} \n (${duration})
          `;
      }
    }

    return Object.values(medicineTexts).join("\n\n");
  }

  return `
    <strong>Motif de consultation:</strong>\n
    <strong>${getMotivesText()}</strong>\n\n\n
  
    <strong class="bold">FDR / Antécédents: </strong>\n\n
    ${await getAntecedentsText({ patient })}\n
    \n\n\n\n
  
    <strong class="bold">Histoire de la maladie: </strong>\n
    ${await getLastStoryText()}\n
    \n\n\n\n
  
    <strong class="bold">Examen clinique: </strong>\n
    ${await getClinicalExaminationText()}\n
    \n\n\n\n
  
    <strong class="bold">Examens réalisés: </strong>\n
    ${await getExamsText()}\n
    \n\n\n\n
  
    <strong class="bold">Examens demandés: </strong>\n
    ${await getExamDemandsText()}\n
    \n\n\n\n
  
    <strong>Ordonnance: </strong>\n 
    ${await getTreatment()}\n
    \n\n\n
    
   
    <strong>Conclusion: </strong>\n
    ${consultation.conclusion || ""}\n
    \n\n\n
    \n\n\n
  
  
  <div class="fright" style="margin-right:25px;">
    Signature de l'assistant responsable
    \n\n\n
    \n\n\n
    \n\n\n
  </div>`;
}
